import { createSelector } from 'reselect';
export const configSelector = (state) => state.config;
export const originSelector = createSelector(configSelector, (config) => config.origin);
